import React from 'react';

import Icon from '../Icon/Icon';

const PreferencesCenterBlueIcon = (props) => {
    return (
        <Icon width='48' height='49' {...props}>
            <g transform='translate(12 6.336)' fill='none' fillRule='evenodd'>
                <rect fill='#00D1D2' x='4.933' y='14.63' width='12' height='12' rx='.5' />
                <path
                    stroke='#34303D'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='M22 14.964v16.733H0v-22h15.334'
                />
                <g stroke='#34303D' strokeLinecap='round' strokeWidth='2'>
                    <path d='m10.222 20.742 14.52-14.519' />
                    <path strokeLinejoin='round' d='M25.778 15.556V5.186h-10.37' />
                </g>
            </g>
        </Icon>
    );
};

export default PreferencesCenterBlueIcon;
